import React, {useContext, useState, useEffect} from 'react';
import _ from "lodash";
import "./announcementManagementForm.scss"
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl';
import FixedHeaderTable from "../../components/FixedHeaderTable";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import IconButton from "@material-ui/core/IconButton";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {DatePicker} from "@material-ui/pickers";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import moment from "moment-timezone";


const columns = [
    { id: 'authorName', label: 'Author Name', minWidth: 170 },
    { id: 'content', label: 'Content', minWidth: 500 },
    {
        id: 'recordCreateDate',
        label: 'Created Date',
        minWidth: 150,
        align: 'right',
        format: (value) => {
            return value? moment(value, "YYYY-MM-DD HH:mm:ss").tz("Asia/Singapore").format('YYYY-MM-DD HH:mma') : "NA"},
    },
    {
        id: 'action',
        label: 'Action',
        minWidth: 170,
        align: 'right',
    },
];

const AnnouncementManagement = () => {
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { getAnnouncements, createAnnouncement, updateAnnouncement } = actions.generalActions;
    const { getAllCourses } = actions.registrationActions;
    const { announcements } = state.generalStates;
    const studentProgramLvl = state.registrationStates.programLvl;
    const { courses } = state.registrationStates;

    const [announcementDetail, setAnnouncementDetail] = useState({});
    const [isDialogVisible, setDialogVisibility] = useState(false);
    const [authorName, setAuthorName] = useState("");
    const [content, setContent] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const [programLvl, setProgramLvl] = React.useState(null);
    // schedule, subjectName, teacherName, programLvl
    const [schedule, setSchedule] = React.useState(null);
    const [course, setCourse] = React.useState(null);

    useEffect(() => {
        getAnnouncements();
        getAllCourses();
    }, []);

    // useEffect(() => {
    //     if (isDialogVisible){
    //         setDialogVisibility(false);
    //     }
    // }, [announcements])


    const handleChange = (event) => {
        setProgramLvl(event.target.value);
    };

    const handleScheduleChange = (event) => {
        setSchedule(event.target.value);
    };

    const handleCourseChange = (event) => {
        setCourse(event.target.value);
    };

    const goBack = () => {
        history.push("/student/management")
    }

    const handleCreateButton = () => {
        setAnnouncementDetail({});
        setAuthorName("Admin");
        setContent("");
        setDialogVisibility(true);
    }

    const onEditClick = () => {
        history.push("/student/management")
    }

    const handleSubmit = () => {
        if (!authorName) {
            setErrorMsg("Please fill in the authorName")
            return;
        }

        if (!content) {
            setErrorMsg("Please fill in the content")
            return;
        }

        if (course && !programLvl) {
            setErrorMsg("Please fill in the program lvl")
            return;
        }

        if (programLvl && !course) {
            setErrorMsg("Please fill in the course")
            return;
        }

        if (!announcementDetail.id) {
            createAnnouncement(authorName, content, programLvl, course, schedule)
        } else {
            updateAnnouncement(announcementDetail.id, authorName, content, programLvl, course, schedule)
        }

        clearAll();
        setDialogVisibility(false);
    };

    const handleClose = () => {
        clearAll();
        setDialogVisibility(false);
    };

    const clearAll = () =>  {
        setContent("");
        setErrorMsg("");
        setProgramLvl(null);
        setCourse(null);
        setSchedule(null)
    }

    const renderAnnouncementDetails = () => {
        return (
            <div>
                <TextField margin="dense" label="Name"
                           value={authorName} fullWidth
                           onChange={ e => setAuthorName(e.target.value)}
                />
                <TextField margin="dense" label="Content" value={content} fullWidth
                           onChange={ e => setContent(e.target.value)}
                />
                <FormControl className="form-control" fullWidth>
                    <InputLabel id="program-lvl-label">Level</InputLabel>
                    <Select
                        labelId="program-lvl-label"
                        value={programLvl}
                        onChange={handleChange}>
                        <MenuItem value={1}>Remove</MenuItem>
                        <MenuItem value={2}>Form 1</MenuItem>
                        <MenuItem value={3}>Form 2</MenuItem>
                        <MenuItem value={4}>Form 3</MenuItem>
                        <MenuItem value={5}>Form 4</MenuItem>
                        <MenuItem value={6}>Form 5</MenuItem>
                        <MenuItem value={8}>Form 5 (Graduated)</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className="form-control" fullWidth>
                    <InputLabel id="type-label">Schedule</InputLabel>
                    <Select
                        labelId="type-label"
                        value={schedule}
                        onChange={handleScheduleChange}>
                        <MenuItem value={"MORNING"}>Morning</MenuItem>
                        <MenuItem value={"AFTERNOON"}>Afternoon</MenuItem>
                        <MenuItem value={"ALL"}>All</MenuItem>
                    </Select>
                </FormControl>

                <FormControl className="form-control" fullWidth>
                    <InputLabel id="type-label">Course</InputLabel>
                    <Select
                        labelId="type-label"
                        value={course}
                        onChange={handleCourseChange}>
                        {
                            courses && courses.map((value, index) => {
                                return (
                                    <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                                );
                            })
                        }
                    </Select>
                </FormControl>
            </div>
        )
    };

    const onViewDetailClick = (id) => {
        let detail = _.find(announcements, {id});
        setAnnouncementDetail(detail);
        setAuthorName(detail.authorName);
        setContent(detail.content);
        setProgramLvl(detail.programLvl);
        setCourse(detail.subjectId);
        setSchedule(detail.schedule);
        setDialogVisibility(true);
    };

    return (
        <div className="announcement-management-form-container">
            <IconButton className="arrowBack" aria-label="back" onClick={() => {goBack()}}>
                <ArrowBackIosIcon fontSize="small" color="primary"/> <span>BACK</span>
            </IconButton>
            <h1 className="header">Announcements Management</h1>
            <div className="paperContainer">
                <Button className="create-btn" variant="contained" color="primary" onClick={handleCreateButton}>
                    Create
                </Button>
            </div>
            <div className="table-container">
                {announcements && <FixedHeaderTable columns={columns} rows={announcements} buttonContent="Edit" buttonAction={onViewDetailClick}/>}
            </div>

            <Dialog open={isDialogVisible} onClose={handleClose} aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth = {'md'}>
                <DialogTitle id="form-dialog-title"><h2>Announcements Details</h2></DialogTitle>
                <DialogContent>
                    {renderAnnouncementDetails()}
                    <div className="inline-error">{errorMsg}</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default withRouter(AnnouncementManagement);
